'use strict';

module.exports = {
    trainData: /*@ngInject*/  ['TripService', '$stateParams', '$q', 'TimeZoneFactory', function (TripService, $stateParams, $q, TimeZoneFactory) {
        var deferred = $q.defer();

        var utcStart = TimeZoneFactory.formatWithTimeZone(angular.copy($stateParams.startDate));
        var utcEnd = TimeZoneFactory.formatWithTimeZone(angular.copy($stateParams.endDate));

        if ( $stateParams.projectId && $stateParams.trainId) {
            TripService.getPeriodData(utcStart, utcEnd, $stateParams.projectId, $stateParams.trainId, function (data) {
                deferred.resolve(
                    {
                        'relativeTrainId': data.trainId,
                        'from': data.departure,
                        'to': data.arrival,
                        'projectId': data.projectId,
                        'projectName': data.projectName,
                        'isTrip': false,
                        'tripId': data.id,
                        'trajectory': data.trajectory,
                        'statistics': data.statistics,
                        'officialId': data.officialId,
                        'trainName': data.trainName
                    }
                );
            });
        } else {
            deferred.resolve(null);
        }

        return deferred.promise;
    }],
    boxDiscriminationInfo: /*@ngInject*/  ['ConfigurationResourceService', '$q', '$stateParams', 'TimeZoneFactory', function (ConfigurationResourceService, $q, $stateParams, TimeZoneFactory) {
        var utcStart = TimeZoneFactory.formatWithTimeZone(angular.copy($stateParams.startDate));
        var utcEnd = TimeZoneFactory.formatWithTimeZone(angular.copy($stateParams.endDate));
        var period = {start: utcStart, end: utcEnd};
        return resolveDiscriminators('box', ConfigurationResourceService, $stateParams, $q, period);
    }],
    coachDiscriminationInfo: /*@ngInject*/  ['ConfigurationResourceService', '$q', '$stateParams', 'TimeZoneFactory', function (ConfigurationResourceService, $q, $stateParams, TimeZoneFactory) {
        var utcStart = TimeZoneFactory.formatWithTimeZone(angular.copy($stateParams.startDate));
        var utcEnd = TimeZoneFactory.formatWithTimeZone(angular.copy($stateParams.endDate));
        var period = {start: utcStart, end: utcEnd};
        return resolveDiscriminators('coach', ConfigurationResourceService, $stateParams, $q, period);
    }],
    obisDiscriminationInfo: /*@ngInject*/  ['ConfigurationResourceService', '$q', '$stateParams', 'TimeZoneFactory','ProjectService','ConfigurationStoreService', function (ConfigurationResourceService, $q, $stateParams, TimeZoneFactory, ProjectService, ConfigurationStoreService) {
        var utcStart = TimeZoneFactory.formatWithTimeZone(angular.copy($stateParams.startDate));
        var utcEnd = TimeZoneFactory.formatWithTimeZone(angular.copy($stateParams.endDate));
        var period = {start: utcStart, end: utcEnd};
        return ConfigurationResourceService.noc().get({
            projectId: ProjectService.getSelectedProjectId()
        }).$promise.then(function(result){
            var data = result && result.data;
            var obisEnabled =  (data && data.dashboardConfiguration) ? (data.dashboardConfiguration.dashboardHideObis === undefined ? false : !data.dashboardConfiguration.dashboardHideObis) : false;
            if(obisEnabled) {
                return resolveDiscriminators("obis", ConfigurationResourceService, $stateParams, $q, period);
            } else {
                return null;
            }
        });
    }]
};

function resolveDiscriminators(type, ConfigurationResourceService, params, $q, period) {
    var deferred = $q.defer();
    if (params.trainId && params.projectId) {
        var criteria = {
            'trainId': params.trainId,
            'projectId': params.projectId,
            'from': period.start,
            'to': period.end
        };
        var callback = function (data) {
            deferred.resolve(data);
        };
    
        switch (type){
            case 'box':     ConfigurationResourceService.getBoxDiscriptors(criteria, callback); break;
            case 'coach':   ConfigurationResourceService.getCoachDiscriptors(criteria, callback); break;
            case 'obis':   ConfigurationResourceService.getObisDiscriptors(criteria, callback); break; 
        }
    
    } else {
        deferred.resolve(null);
    }

    return deferred.promise;
}